export function getStatusStyle(status: number | null): string {
  switch (status) {
    case 1: // PendingPayment
    case 5: // PendingCancelation
      return 'bg-amber-100 text-amber-800';
    case 2: // PendingDelivery
      return 'bg-blue-100 text-blue-800';
    case 3: // Delivered
      return 'bg-green-100 text-green-800';
    case 4: // Canceled
    case 6: // CanceledMissingOnlinePayment
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-100 text-gray-600';
  }
}
